function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { filterByType, filterByTypes } from "../../../data";
import { useApplicationPageAggregatedData, useApplicationPageMutation } from "./aggregatedData";
import { assert } from "../../../utils/assert";
import { useApplication } from "./application";
import { parse } from "../../../utils/parse";
import { Note } from "../../../types/Note";
import { NoteUser } from "../../../types/NoteUser";
export function useUpdateNote() {
  var _useApplicationPageMu = useApplicationPageMutation(function (_ref) {
      var acceptedByApplicant = _ref.acceptedByApplicant,
        noteId = _ref.noteId,
        read = _ref.read,
        resolved = _ref.resolved;
      assert(read !== undefined || resolved !== undefined || acceptedByApplicant !== undefined, 'Either "read", "resolved", or "acceptedByApplicant" must be provided');
      return {
        url: "/awa/v1/notes/".concat(noteId),
        method: 'PATCH',
        body: {
          data: {
            id: noteId,
            type: 'application_customer_note',
            attributes: _objectSpread(_objectSpread(_objectSpread({}, read !== undefined && {
              read: read
            }), resolved !== undefined && {
              resolved: resolved
            }), acceptedByApplicant !== undefined && {
              acceptedByApplicant: acceptedByApplicant
            })
          }
        }
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    status = _useApplicationPageMu.status;
  return {
    updateApplicationNote: mutate,
    updateApplicationNoteStatus: status
  };
}
export function useCreateNote() {
  var _useApplication = useApplication(),
    appId = _useApplication.application.id;
  var _useApplicationPageMu2 = useApplicationPageMutation(function (_ref2) {
      var type = _ref2.type,
        subject = _ref2.subject,
        content = _ref2.content,
        parentNoteId = _ref2.parentNoteId,
        noteTemplateNumber = _ref2.noteTemplateNumber,
        _ref2$flags = _ref2.flags,
        _ref2$flags$restricte = _ref2$flags.restricted,
        restricted = _ref2$flags$restricte === void 0 ? false : _ref2$flags$restricte,
        _ref2$flags$emailNoti = _ref2$flags.emailNotification,
        emailNotification = _ref2$flags$emailNoti === void 0 ? false : _ref2$flags$emailNoti,
        attachments = _ref2.attachments;
      var requestBody = {
        data: {
          type: type,
          attributes: {
            applicationIds: [appId.toString()],
            content: content,
            contentEncoding: 'markdown',
            subject: subject,
            flags: {
              restricted: restricted,
              emailNotification: emailNotification
            },
            noteTemplateNumber: noteTemplateNumber,
            parentNoteId: parentNoteId,
            attachments: attachments
          }
        }
      };
      return {
        url: '/awa/v1/notes',
        method: 'POST',
        body: requestBody
      };
    }),
    mutate = _useApplicationPageMu2.mutate,
    status = _useApplicationPageMu2.status;
  return {
    createNote: mutate,
    createNoteStatus: status
  };
}
export function useDeleteNote() {
  var _useApplicationPageMu3 = useApplicationPageMutation(function (_ref3) {
      var noteId = _ref3.noteId;
      return {
        url: "/awa/v1/notes/".concat(noteId),
        method: 'DELETE'
      };
    }),
    mutate = _useApplicationPageMu3.mutate,
    status = _useApplicationPageMu3.status;
  return {
    deleteNote: mutate,
    deleteNoteStatus: status
  };
}
export function useAcceptAbbieNote() {
  var _useApplicationPageMu4 = useApplicationPageMutation(function (_ref4) {
      var noteId = _ref4.noteId,
        parentNoteId = _ref4.parentNoteId;
      return {
        url: "/notes/".concat(noteId, "/actions"),
        method: 'POST',
        body: {
          data: {
            type: 'note_action',
            attributes: {
              actionId: 'accept_abbie_note',
              actionData: {
                parentNoteId: parentNoteId
              }
            }
          }
        }
      };
    }),
    mutate = _useApplicationPageMu4.mutate,
    status = _useApplicationPageMu4.status;
  return {
    acceptAbbieNote: mutate,
    acceptAbbieNoteStatus: status
  };
}
export function useNotes(type) {
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(data) {
        return filterByTypes(data.included, type ? [type] : ['application_customer_note', 'application_admin_note']).map(function (note) {
          return parse(Note, _objectSpread(_objectSpread({}, note.attributes), {}, {
            id: note.id,
            type: note.type
          }));
        });
      }
    }),
    data = _useApplicationPageAg.data;
  return {
    applicationNotes: data || []
  };
}
export function useNoteUser(legacyUserId) {
  var _useApplicationPageAg2 = useApplicationPageAggregatedData({
      select: function select(data) {
        return filterByType(data.included, 'note_user').find(function (user) {
          return user.id === legacyUserId;
        });
      }
    }),
    user = _useApplicationPageAg2.data;
  if (!legacyUserId) {
    return {
      noteUser: null
    };
  }
  assert(user, "User with legacy ID ".concat(legacyUserId, " not found"));
  return {
    noteUser: parse(NoteUser, _objectSpread(_objectSpread({}, user.attributes), {}, {
      id: user.id
    }))
  };
}
export function useNote(noteId) {
  var _useApplicationPageAg3 = useApplicationPageAggregatedData({
      select: function select(data) {
        return filterByTypes(data.included, ['application_customer_note', 'application_admin_note']).find(function (note) {
          return note.id === noteId;
        });
      }
    }),
    note = _useApplicationPageAg3.data;
  assert(note, "Note with ID ".concat(noteId, " not found"));
  return {
    applicationNote: parse(Note, _objectSpread({
      id: note.id,
      type: note.type
    }, note.attributes))
  };
}